import { get } from 'lodash'
import { required } from 'utils/validation'

const validate = values => {
  return {
    observations: required(get(values, 'observations')),
  }
}

export default validate
